import React, { ReactNode } from 'react';

import { Text, View } from 'react-native';

import styles from './styles';

interface IProps {
    alignCenter?: boolean;
    title?: string | ReactNode;
    subTitle?: string;
    loading?: boolean;
}

const MOCK_LOADING_TEXT = 'Loading';

export const TileTitle = ({
    title,
    subTitle,
    alignCenter,
    loading = false,
}: IProps) => (
    <View style={styles.container} accessibilityRole="text" accessible>
        <View style={loading && styles.loadingContainer}>
            <Text
                numberOfLines={1}
                style={[
                    styles.title,
                    alignCenter && styles.alignCenter,
                    loading && styles.loadingText,
                ]}
            >
                {loading ? MOCK_LOADING_TEXT : title || ''}
            </Text>
        </View>
        {subTitle ? (
            <Text
                numberOfLines={1}
                style={[styles.subTitle, alignCenter && styles.alignCenter]}
            >
                {subTitle}
            </Text>
        ) : null}
    </View>
);
